module.exports = __webpack_public_path__ + "img/message_active_fit.69dd06cc.svg";